import axios from "axios";
import { store } from "../../redux/store/store";
import { logout } from "../../redux/reducer/LoginReducer/LoginReducer";
import { LOGIN } from "../utils/RouteConstant";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "x-api-key": process.env.REACT_APP_API_KEY,
    accept: "application/json",
  },
});

axiosInstance.interceptors.request.use(
  function configuration(config) {
    const token =
      // store.getState().auth.token ||
      localStorage.getItem("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response && error.response.status === 401) {
        if (LOGIN !== "/") {
          store.dispatch(logout());
          window.location.href = LOGIN;
        }
      // store.dispatch(logout());
      // window.location.href = LOGIN;
    } else if (
      error.response &&
      error.response.data.message === "Your token is invalid."
    ) {
      store.dispatch(logout());
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export { axiosInstance };
